export const isNanoId = (id) => {
  // Regular expression pattern to match Nano ID characteristics
  const nanoIdPattern = /^[a-zA-Z0-9_-]{21}$/;

  return nanoIdPattern.test(id);
}